import { ValueOf } from '@/types/util';

export const EWalletUserLoginMethod = {
  PHONE: 'SMS認証',
  EMAIL: 'メールアドレス認証',
  PASSWORD: 'パスワード認証',
  JWT: 'JWT認証',
} as const;

export type WalletUserLoginMethodKey = keyof typeof EWalletUserLoginMethod;
export type WalletUserLoginMethodValue = ValueOf<typeof EWalletUserLoginMethod>;

export const walletUserLoginMethodKeys = Object.keys(EWalletUserLoginMethod) as WalletUserLoginMethodKey[];

/** v-select用items */
export const walletUserLoginMethodItems = walletUserLoginMethodKeys
  .map((key) => ({
    title: EWalletUserLoginMethod[key],
    value: key,
  }));
